import { render } from "./PagesCreate.vue?vue&type=template&id=61b30b44&scoped=true"
import script from "./PagesCreate.vue?vue&type=script&lang=js"
export * from "./PagesCreate.vue?vue&type=script&lang=js"

import "./PagesCreate.vue?vue&type=style&index=0&id=61b30b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b30b44"]])

export default __exports__